/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { SalesLine, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { ObjectExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { observable } from 'mobx';

/**
 * Represents a product from order details.
 */
export class OrderDetailsProduct {
    @observable
    public isSelected: boolean;

    public readonly isProductAvailable: boolean;

    public readonly salesLine: SalesLine;

    /**
     * Simple product info.
     * May be undefined for the removed/unavailable product.
     */
    public readonly simpleProduct?: SimpleProduct;

    public readonly productUrl?: string;

    public constructor(salesLine: SalesLine, simpleProduct?: SimpleProduct, productUrl?: string) {
        this.salesLine = salesLine;
        this.simpleProduct = simpleProduct;
        this.isSelected = false;
        this.isProductAvailable = !ObjectExtensions.isNullOrUndefined(simpleProduct);
        this.productUrl = productUrl;
    }
}
